import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BeanMonitoria } from 'src/bean/BeanMonitoria';
import { environment } from 'src/environments/environment';

@Injectable()
export class FeedbackLoginDialogService {

    constructor(
    private http: HttpClient
    ) { }

    public getHeaders(){

        const tokenString = localStorage.getItem('access_token');

        const headers = {
            'Authorization' : 'Bearer ' + tokenString,
            'Content-Type': 'application/json'
        };

        return headers;
    }

    assinarFeedback(beanMonitoriaFeedback: BeanMonitoria, userAvaliadoId:number, userAvaliadoRe:string, userAvaliadoPasswd:string, monitoryId:number):Observable<any>{

        const headers = this.getHeaders();

        let json = JSON.stringify(beanMonitoriaFeedback);
            
        return this.http.put(environment.urlBackend +  environment.atualizaFeedback + userAvaliadoId + '/' + userAvaliadoRe + '/' + userAvaliadoPasswd + '/' + monitoryId, json, {headers})
        
    }


}
